import {
  DialogDescription,
  DialogDismiss,
  DialogHeading,
  Form,
  useDialogContext,
} from "@ariakit/react";
import { ReactNode } from "react";
import { atomic } from "../atomic.css";
import { DialogSubmitButton } from "../dialog-buttons";
import { useForm } from "../hooks/use-form";
import { ModalDialog } from "../modal-dialog";

export function ConfirmDialog(props: {
  heading: string;
  description: ReactNode;
  submitLabel: string;
  onSubmit: () => void | Promise<void>;
}) {
  const store = useDialogContext();
  const form = useForm({
    defaultValues: {},
    async onSubmit() {
      await props.onSubmit();
      store?.hide();
    },
  });

  return (
    <ModalDialog variant="confirm">
      <Form store={form} autoComplete="off" className={atomic({ padding: 32 })}>
        <DialogHeading
          className={atomic({
            fontFamily: "barlow-condensed",
            fontWeight: "semi-bold",
            textAlign: "center",
            marginBlockEnd: 8,
            lineHeight: 1,
          })}
        >
          {props.heading}
        </DialogHeading>
        <DialogDescription
          className={atomic({
            fontSize: 18,
            lineHeight: 1.5,
            textAlign: "center",
          })}
        >
          {props.description}
        </DialogDescription>

        <div
          className={atomic({
            marginBlockStart: 32,
            display: "flex",
            flexDirection: "column-reverse",
            gap: 12,
          })}
        >
          <DialogDismiss
            className={atomic({
              fontFamily: "arboria",
              fontWeight: "black",
              fontStyle: "italic",
              fontSize: 18,
              textTransform: "uppercase",
              padding: 20,
              border: "solid",
              transition: "background-color",
              backgroundColor: { hover: "background-secondary" },
            })}
          >
            Cancel
          </DialogDismiss>
          <DialogSubmitButton>{props.submitLabel}</DialogSubmitButton>
        </div>
      </Form>
    </ModalDialog>
  );
}
